// @ts-nocheck

import UserOutlined from '@ant-design/icons/UserOutlined';
import SmileOutlined from '@ant-design/icons/SmileOutlined';
import BugOutlined from '@ant-design/icons/BugOutlined';
import PartitionOutlined from '@ant-design/icons/PartitionOutlined'

export default {
  UserOutlined,
SmileOutlined,
BugOutlined,
PartitionOutlined
}
    